import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {Router} from "@angular/router";


@Component({
    selector: 'db-agency-partner-program-dialog',
    templateUrl: './agency-partner-program-dialog.component.html',
    styleUrls: ['./agency-partner-program-dialog.component.scss'],
    standalone: false
})
export class AgencyPartnerProgramDialogComponent extends DialogComponent<any, Boolean>  implements OnInit {

  @Input() from?: string;
  @Input() width?: string;
  @Input() title: string;
  @Input() body: string;
  @Input() btn?: string;

  public loading: boolean;
  constructor(
    private _dialogService: DialogService,
    private _router: Router
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
  }

  public confirm(): void {
    switch (this.from) {
      case 'invite_user':
        this._router.navigate(['/user-management']);
        this.close();
        break;
      default:
        this.close();
    }
  }
}
